import * as _ from 'lodash-es';

const KEY = 'searchQueryId';

const MAX_AGE = 5 * 1000;

type SearchContext = {
  queryId?: string;
  resultId?: string;
  position?: number;
  highlightedRangeIndex?: number;
};

type SearchQueryValue = Record<
  string,
  SearchContext & {
    timestamp: number;
  }
>;

const getValue = (): SearchQueryValue => {
  const now = Date.now();
  return _.pickBy(
    JSON.parse(localStorage.getItem(KEY) ?? '{}') ?? {},
    (item) => now - item.timestamp <= MAX_AGE,
  );
};

const saveValue = (value: SearchQueryValue) =>
  localStorage.setItem(KEY, JSON.stringify(value));

export const saveSearchContext = (postId: string, context: SearchContext) =>
  saveValue({
    ...getValue(),
    [postId]: { ...context, timestamp: Date.now() },
  });

export const getSearchContext = (postId: string): SearchContext => {
  const value = getValue();

  // Save value without expired fields
  saveValue(value);

  return value[postId] ?? {};
};
